import { useTranslation } from "react-i18next";
import { Label } from "@radix-ui/react-label";
import { Input } from "@/components/ui/input";
import { EmailIcon } from "./assets";

function EmailForm({ email }: { email: string }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium text-i-normal">
        {t("settings_account.email_form.email_address")}
      </Label>
      <div className="relative">
        <EmailIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-i-sub w-4 h-4" />
        <Input
          value={email}
          className="px-3.5 pl-10 py-2.5 read-only:text-i-sub rounded-sm focus-visible:ring-0 focus-visible:ring-offset-0 border-[rgba(208,213,221,1)] read-only:bg-[rgba(249,250,251,1)] shadow-[0px_1px_2px_rgba(16,24,40,0.05)]"
          placeholder={t("settings_account.email_form.email_address")}
          type="email"
          readOnly
        />
      </div>
    </div>
  );
}

export default EmailForm;